export function getSeriesColorFn(series) {
  return series.colorGetter ? series.colorGetter : () => series.color;
}